module.exports = __webpack_public_path__ + "static/media/antigua-historic-6.ff8cda05.jpg";